import { useState } from 'react';
import { toast } from 'react-toastify';
import Box from '../../../../components/Section/Box';
import { Categories, Actions, Labels } from '../../../../types/gtm';
import { ListSession } from '../../../../types/session';
import Button from '../../../../components/Button';
import {
  DivButton,
  SessionContent,
  ListSessions,
  RemoveSessionMessage,
  ModalBody,
  ModalFooter,
} from './styles';
import { useAuth } from '../../../../hooks/useAuth';
import Modal from './Modal';
import DropDownSession from './DropDownSession';
import { deleteWithSessionData } from '../../../../services/session';

export type BoxSessionProps = {
  sessionInfo: ListSession[];
  isBetaUser: boolean;
};

const BoxSession = ({ sessionInfo, isBetaUser }: BoxSessionProps) => {
  window.dataLayer = window.dataLayer || [];
  const { user, authenticateOnAPI } = useAuth();
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const title = 'Aparelhos conectados';

  const getDescribeTitle = () => {
    if (isBetaUser) {
      return (
        <>
          Você está conectado <strong>nesses dispositivos</strong>. Para sua
          segurança, você pode desconectar sua conta de qualquer aparelho que
          não reconheça.
        </>
      );
    }
    return 'Verifique os aparelhos em que acessou os serviços Globo.';
  };

  const [infoSession, setInfoSession] = useState<ListSession[]>(
    sessionInfo || [],
  );

  async function removeAll() {
    setModalOpen(false);

    const sessions = await deleteWithSessionData(
      infoSession,
      authenticateOnAPI,
      isBetaUser,
    );

    if (sessions === null) {
      toast.error('Não foi possível desconectar as sessões dos dispositivos!');
    } else {
      setInfoSession(sessions);
      toast.success('Dispositivos desconectados com sucesso!');
    }
  }

  const ConfirmModal = () => {
    return (
      <Modal
        header="Deseja sair de todos aparelhos?"
        closeButton={() => setModalOpen(false)}
        borderRadius="16px"
      >
        <ModalBody>
          <p>
            A Conta Globo é uma conta única. Ao sair, você será desconectado de
            todos os serviços Globo em todos aparelhos.
          </p>
        </ModalBody>
        <ModalFooter>
          <Button variant="secondary" width="100%" onClick={() => removeAll()}>
            Sair
          </Button>
          <Button variant="primary" onClick={() => setModalOpen(false)}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>
    );
  };

  function removeSessionState(sessionIds: string[]) {
    if (sessionIds.length === 0) return;

    const sessionIdSet = new Set(sessionIds);

    const newValue = infoSession.map(itemInfoSession => {
      const filteredSessions = itemInfoSession.sessions.filter(session => {
        const hasSessionId =
          session.sessionId && sessionIdSet.has(session.sessionId);
        const hasSessionIds = session.sessionIds?.some((id: string) =>
          sessionIdSet.has(id),
        );
        return !hasSessionId && !hasSessionIds;
      });

      if (filteredSessions.length === itemInfoSession.sessions.length) {
        return itemInfoSession;
      }

      return {
        ...itemInfoSession,
        sessions: filteredSessions,
      };
    });

    if (JSON.stringify(newValue) !== JSON.stringify(infoSession)) {
      setInfoSession(newValue);
    }
  }

  return (
    <Box title={title} describeTitle={getDescribeTitle()}>
      <SessionContent className="mcv3-card">
        {isBetaUser ? (
          <ListSessions>
            {infoSession.map(itemSession => (
              <DropDownSession
                key={`${itemSession.device}-${itemSession.displayName}`}
                itemSession={itemSession}
                isBetaUser={isBetaUser}
                removeSessionState={removeSessionState}
              />
            ))}
          </ListSessions>
        ) : (
          <RemoveSessionMessage>
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
              >
                <path d="M0 0H32V32H0V0Z" fill="white" />
                <path
                  d="M16 2.66663C8.63996 2.66663 2.66663 8.63996 2.66663 16C2.66663 23.36 8.63996 29.3333 16 29.3333C23.36 29.3333 29.3333 23.36 29.3333 16C29.3333 8.63996 23.36 2.66663 16 2.66663ZM16 22.6666C15.2666 22.6666 14.6666 22.0666 14.6666 21.3333V16C14.6666 15.2666 15.2666 14.6666 16 14.6666C16.7333 14.6666 17.3333 15.2666 17.3333 16V21.3333C17.3333 22.0666 16.7333 22.6666 16 22.6666ZM17.3333 12H14.6666V9.33329H17.3333V12Z"
                  fill="#666666"
                />
              </svg>
              <p>Deseja desconectar de todas as sessões?</p>
            </div>
            <hr aria-hidden />
          </RemoveSessionMessage>
        )}

        <DivButton>
          <Button
            variant="primary"
            onClick={() => {
              window.dataLayer.push({
                event: 'customEventUserInteraction',
                event_category: Categories.Home,
                event_action: Actions.ClickDisconnectAll,
                event_label: Labels.Home,
                bd_suser_code: user?.globoId,
              });
              setModalOpen(true);
            }}
          >
            {isBetaUser ? 'Sair de todos aparelhos' : 'Sair'}
          </Button>
        </DivButton>
        {modalOpen && <ConfirmModal />}
      </SessionContent>
    </Box>
  );
};

export default BoxSession;
